import { render, staticRenderFns } from "./SharedMainPoint.template.vue?vue&type=template&id=e7f4db56&scoped=true&"
var script = {}
import style0 from "./SharedMainPoint.template.vue?vue&type=style&index=0&id=e7f4db56&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f4db56",
  null
  
)

export default component.exports